export default __webpack_public_path__ + "b980cf3.png";